export const customTranslate = () =>
  tinymce.addI18n(i18n.locale, {
    "Link list": i18n.t('tinymce.link_template')
  });
